import * as angular from 'angular';

angular.module('app').filter('fileExtension', fileExtension);

function fileExtension() {
	return function (fileName) {
		return (fileName || '').substr((fileName || '').lastIndexOf('.') + 1);
	};
}
